import { FormControl, Select, MenuItem } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { FilterProperties } from "../../Models/FilterProperties";
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { SingleInputDateRangeField } from '@mui/x-date-pickers-pro/SingleInputDateRangeField';
import { GetFilters } from "../../Services/Properties";
import { useTranslation } from "react-i18next";

const yesterday = dayjs().subtract(1, 'day');
const today = dayjs();

const Filters: React.FunctionComponent<{ filterOptionsValue: any, OnChangeFilter: any }> = (props) => {

    const [filterValue, setFilterValue] = useState<FilterProperties>(props.filterOptionsValue);
    const [dataFilters, setDataFilters] = useState<any>();
    const { t } = useTranslation();

    useEffect(() => {
        GetFilters().then((resp) => {
            setDataFilters(resp)
        }).catch((err) => {
            console.log(err);
        })
    }, [])

    useEffect(() => {
        props.OnChangeFilter(filterValue);
    }, [filterValue]);

    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setFilterValue((prev) => ({ ...prev, [name]: value }));
    };

    const handleSelectChangeDate = (range: any) => {
        setFilterValue(prevOptions => ({
            ...prevOptions,
            date: range,
        }));
    }

    const HandleClickFilter = () => {
        setFilterValue({})
        props.OnChangeFilter({})
    }

    return (
        <div className="row marg-20">

            <div className="col-md-3">
                <label htmlFor="portalSelect" className="form-label"> {t('propertiesPage.agent')}</label>
                <FormControl fullWidth>
                    <Select
                        className="custom-select mb-3"
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={filterValue.agent || ""}
                        onChange={handleChange}
                        name="agent"
                        sx={{
                            '.MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                                borderRadius: "10px"
                            },
                        }}>
                        <MenuItem value="" >
                            {t('propertiesPage.select')}
                        </MenuItem>
                        {dataFilters && dataFilters.agents && dataFilters.agents.map((obj: any, index: any) => {
                            return <MenuItem value={obj} key={index}>{obj}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-3">
                <label htmlFor="portalSelect" className="form-label">{t('propertiesPage.city')}</label>
                <FormControl fullWidth>
                    <Select
                        className="custom-select mb-3"
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={filterValue.city || ""}
                        onChange={handleChange}
                        name="city"
                        sx={{
                            '.MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                                borderRadius: "10px"
                            },
                        }}>
                        <MenuItem value="" >
                            {t('propertiesPage.select')}
                        </MenuItem>
                        {dataFilters && dataFilters.cities && dataFilters.cities.map((obj: any, index: any) => {
                            return <MenuItem value={obj} key={index}>{obj}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-3">
                <label htmlFor="portalSelect" className="form-label">{t('propertiesPage.dateRange')}</label>
                <FormControl fullWidth>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer
                            components={['SingleInputDateRangeField', 'SingleInputDateRangeField']}
                            sx={{ borderRadius: "10px", background: "#F4F4F5" }}
                        >
                            <SingleInputDateRangeField
                                defaultValue={[yesterday, today]}
                                onChange={(newValue) => handleSelectChangeDate(newValue)}
                                name="date"
                                sx={{
                                    '.MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                        borderRadius: "10px"
                                    },
                                }}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                </FormControl>
            </div>

            <div className="col-md-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("propertyDetails.offeringType")} </label>
                <FormControl fullWidth>
                    <Select
                        className={`custom-select mb-3`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={filterValue.offeringType || ''}
                        name="offeringType"
                        onChange={handleChange}
                    >
                        <MenuItem value="" disabled>{t("propertyDetails.select")}</MenuItem>
                        <MenuItem value={"for-sale"}>{t("propertyDetails.sale")}</MenuItem>
                        <MenuItem value={"for-rent"}>{t("propertyDetails.rent")}</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("propertyDetails.propertyType")} </label>
                <FormControl fullWidth>
                    <Select
                       className={`custom-select mb-3`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        value={filterValue.propertyType || ''}
                        name="propertyType"
                        onChange={handleChange}
                    >
                        <MenuItem value="" disabled>
                            {t("propertyDetails.select")}
                        </MenuItem>
                        {dataFilters && dataFilters.propertyTypes && dataFilters.propertyTypes.map((obj: any, index: any) => {
                            return <MenuItem value={obj} key={index}>{obj}</MenuItem>
                        })}
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("propertyDetails.bedrooms")}</label>
                <FormControl fullWidth>
                    <Select
                        className={`custom-select mb-3`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        name="bedrooms"
                        value={filterValue.bedrooms || ""}
                        onChange={handleChange}
                        sx={{
                            '.MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                                borderRadius: "10px"
                            },
                        }}
                    >
                        <MenuItem value="" disabled>{t("propertyDetails.select")}</MenuItem>
                        <MenuItem value={"Studio"}>{t("propertyDetails.studio")}</MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                        <MenuItem value={"4"}>4</MenuItem>
                        <MenuItem value={"5"}>5</MenuItem>
                        <MenuItem value={"6"}>6</MenuItem>
                        <MenuItem value={"7"}>7</MenuItem>
                        <MenuItem value={"8"}>8</MenuItem>
                        <MenuItem value={"9"}>9</MenuItem>
                        <MenuItem value={"10"}>10</MenuItem>
                        <MenuItem value={"11"}>11</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-3">
                <label className="form-label-1 mb-2" htmlFor="selectTypeOpt">{t("propertyDetails.bathrooms")}</label>
                <FormControl fullWidth>
                    <Select
                        className={`custom-select mb-3`}
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select' }}
                        name="bathrooms"
                        value={filterValue.bathrooms || ""}
                        onChange={handleChange}
                        sx={{
                            '.MuiOutlinedInput-notchedOutline': {
                                border: 'none',
                                borderRadius: "10px"
                            },
                        }}
                    >
                        <MenuItem value="" disabled> {t("propertyDetails.select")} </MenuItem>
                        <MenuItem value={"1"}>1</MenuItem>
                        <MenuItem value={"2"}>2</MenuItem>
                        <MenuItem value={"3"}>3</MenuItem>
                        <MenuItem value={"4"}>4</MenuItem>
                        <MenuItem value={"5"}>5</MenuItem>
                        <MenuItem value={"6"}>6</MenuItem>
                        <MenuItem value={"7"}>7</MenuItem>
                        <MenuItem value={"8"}>8</MenuItem>
                        <MenuItem value={"9"}>9</MenuItem>
                        <MenuItem value={"10"}>10</MenuItem>
                        <MenuItem value={"11"}>11</MenuItem>
                    </Select>
                </FormControl>
            </div>

            <div className="col-md-12 justify-content-end d-flex ">
                <button type="submit" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30" onClick={HandleClickFilter} >
                    {t('propertiesPage.reset')}
                </button>
            </div>
        </div>
    )
}
export default Filters;